import { Oriented } from "@/data/constants/oriented";
import { OverviewOrientation } from "@/features/analysis/services/symbol-overview";

type Score = number;
type OrientationIndicators = Partial<Record<Oriented, Score>>;

export const indicatorScoresMap: Record<
  OverviewOrientation,
  OrientationIndicators
> = {
  value: {
    value: 4,
    dividend: 2,
  },
  trend: {
    trend: 4,
    value: 2,
  },
  swing: {
    swing: 4,
    value: 2,
  },
  dividend: {
    dividend: 4,
    trend: 2,
  },
};
